import i from 'i18next'

export const getTitle = ( collection ) => (
	i.t( [ `collection.${collection.handle}`, collection.title ] )
)

const Title = ({ collection }) => <>{getTitle( collection )}</>
export default Title
